import React from "react";
import {Helmet} from "react-helmet";

function Copyright(props) {
  return (
    <div className="Copyright">
      <Helmet>
         <script type="application/ld+json">
              {JSON.stringify({
                  "@context" : "https://schema.org",
                  "@type" : "LocalBusiness",
                  "name" : "Contacta Abogados",
                  "priceRange" : "$$",
                  "image" : "https://contactaabogado.com/img/logo/Logo_contacta.jpg",
                  "url" : "https://contactaabogado.com/",
                  "telephone" : "+525541606061",
                  "address" : "Hamburgo 70, Juárez, Cuauhtémoc, 06600 Ciudad de México, CDMX",
                  "sameAs" : [
                  "https://www.facebook.com/contactaabogado/",
                  "https://www.linkedin.com/company/contactaabogado/", 
                  "https://www.instagram.com/contactaabogado_/",
                  "https://www.youtube.com/channel/UCjfRi8EV-HrQhEP6voDJgYA",
                  "https://twitter.com/contactaabogado"
                  ]
                })}
          </script>
      </Helmet> 
{/*       <p>Copyright © 2018-2019 Contacta Abogado México, S.A. de C.V.</p>
 */}      
       <p>Contacta Abogado® 2020 Todos los derechos reservados. Desarrollado y Diseñado por TGC Internet Group S de RL de CV.</p>
    </div>
  );
}

export default Copyright;
